import { render } from "./비만대사수술클리닉.vue?vue&type=template&id=30d4ce70"
import script from "./비만대사수술클리닉.vue?vue&type=script&lang=js"
export * from "./비만대사수술클리닉.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__